import React from 'react';

const HSL = ({ className }) => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="#232328" />
            <circle className='ac-s' cx="19.8929" cy="26.974" r="4.3929" stroke="white" />
            <circle className='ac-s' cx="26.8421" cy="26.974" r="4.3929" stroke="white" />
            <path className='ac-s' d="M27.7604 20.8929C27.7604 23.319 25.7936 25.2858 23.3675 25.2858C20.9414 25.2858 18.9746 23.319 18.9746 20.8929C18.9746 18.4668 20.9414 16.5 23.3675 16.5C25.7936 16.5 27.7604 18.4668 27.7604 20.8929Z" stroke="white" />
        </svg>

    )
}

export default HSL;